import { render, staticRenderFns } from "./CompCreate.vue?vue&type=template&id=aebaa584&scoped=true"
import script from "./CompCreate.vue?vue&type=script&lang=js"
export * from "./CompCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aebaa584",
  null
  
)

export default component.exports